import Hero from './Hero';
import Testimonials from './Testimonials';
import VideoCallout from './VideoCallout';
import ServiceDetails from './ServiceDetails';

export { Hero, Testimonials, VideoCallout, ServiceDetails };



// WEBPACK FOOTER //
// ./src/components/HomePage/components/index.js